var _excluded = ["startIcon", "endIcon", "style", "type", "disabled", "href", "target", "className", "onClick", "ghost", "danger", "fullWidth", "dashed", "loading"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable no-nested-ternary */
import React from 'react';
import { cx } from '@emotion/css';
import { LoadingOutlinedIcon } from "../Icons";
import { styleButtonType, styleButtonDisabled, styleButtonSize, styleLoadingAnimtion, prefix } from "./index.style";
import { getLightStatusColors, getDarkStatusColors, getDarkDangerColors, disabledLightColorConfig, disabledDarkColorConfig } from "./config";
import { EStatus, EStatusTheme } from "./interface";
import useThemeProps from "../../hooks/useThemeProps";

var InternalButton = function InternalButton(props, ref) {
  var _cx2;

  var startIcon = props.startIcon,
      endIcon = props.endIcon,
      style = props.style,
      type = props.type,
      disabled = props.disabled,
      href = props.href,
      target = props.target,
      className = props.className,
      onClick = props.onClick,
      ghost = props.ghost,
      danger = props.danger,
      fullWidth = props.fullWidth,
      dashed = props.dashed,
      loading = props.loading,
      restProps = _objectWithoutProperties(props, _excluded);

  var c = useThemeProps();

  var clickHandler = function clickHandler(event) {
    var _props$onClick;

    // for a
    if (props.disabled || props.loading) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    props === null || props === void 0 ? void 0 : (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, event);
  };

  var isSyetemThemeDark = c.isSyetemThemeDark;
  var statusClass = React.useMemo(function () {
    if (props[EStatus.DISABLED] || props.loading) {
      return styleButtonDisabled(c, isSyetemThemeDark ? disabledDarkColorConfig : disabledLightColorConfig);
    }

    if (props[EStatus.DANGER]) {
      return styleButtonType(c, isSyetemThemeDark ? getDarkDangerColors(EStatusTheme.DANGER) : getLightStatusColors(EStatusTheme.DANGER));
    }

    return styleButtonType(c, isSyetemThemeDark ? getDarkStatusColors(EStatusTheme.NORMAL) : getLightStatusColors(EStatusTheme.NORMAL)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props[EStatus.DISABLED], props.loading, props[EStatus.DANGER], c, isSyetemThemeDark]);
  var Tag = React.useMemo(function () {
    if (props.href) {
      return 'a';
    }

    return 'button';
  }, [props.href]);
  var renderIcon = React.useCallback(function (className, icon, isUseLoading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, isUseLoading && props.loading ? /*#__PURE__*/React.createElement("span", {
      className: cx(className, _defineProperty({}, styleLoadingAnimtion, props.loading))
    }, /*#__PURE__*/React.createElement(LoadingOutlinedIcon, null)) : icon ? /*#__PURE__*/React.createElement("span", {
      className: cx(className)
    }, icon) : null);
  }, [props.loading]);
  var beforeIcon = React.useMemo(function () {
    return renderIcon(prefix('icon-start')(), startIcon, Boolean(startIcon) || !endIcon);
  }, [renderIcon, startIcon, endIcon]);
  var afterIcon = React.useMemo(function () {
    return renderIcon(prefix('icon-end')(), endIcon, Boolean(endIcon) && !startIcon);
  }, [renderIcon, endIcon, startIcon]);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, restProps, {
    onClick: clickHandler,
    disabled: Boolean(props.disabled),
    style: style // @ts-ignore
    ,
    ref: ref,
    className: cx(prefix(props.size)(), prefix(props.type)(), styleButtonSize(), statusClass, (_cx2 = {}, _defineProperty(_cx2, prefix('ghost')(), Boolean(props.ghost)), _defineProperty(_cx2, prefix('loading')(), Boolean(props.loading)), _defineProperty(_cx2, prefix('dashed')(), Boolean(props.dashed)), _defineProperty(_cx2, prefix('full-width')(), Boolean(props.fullWidth)), _cx2), props.className),
    href: props.href,
    target: props.href ? props.target : undefined
  }), beforeIcon, /*#__PURE__*/React.createElement("span", null, props.children), afterIcon);
};

var Button = /*#__PURE__*/React.forwardRef(InternalButton);
Button.displayName = 'Button';
Button.defaultProps = {
  type: 'primary',
  disabled: false,
  ghost: false,
  danger: false,
  fullWidth: false,
  target: '_blank',
  size: 'medium',
  dashed: false,
  loading: false
};
export default /*#__PURE__*/React.memo(Button);